import { defineStore } from 'pinia';

export const useWorkflowUI = defineStore('bvWorkflowUI', {
  state: () => ({
    showStepsMenu: false,
    showSidePanel: true, // Control side panel visibility
    menuPosition: { x: 0, y: 0 },
    active: false,
  }),

  actions: {
    setActive(active: boolean) {
      this.active = active;
    },

    openStepsMenu(x: number, y: number) {
      if (this.active) {
        return;
      }
      this.showStepsMenu = true;
      this.menuPosition = { x, y };
    },

    closeStepsMenu() {
      this.showStepsMenu = false;
      this.menuPosition = { x: 0, y: 0 };
    },

    toggleSidePanel() {
      if (this.active) {
        return;
      }
      this.showSidePanel = !this.showSidePanel;
    },

    setSidePanelVisibility(visible: boolean) {
      this.showSidePanel = visible;
    },
  },
});
